<blaze-dialog
  (closeDialog)="closeDialog()"
  class="triggers-dialog"
  [showFooter]="!isSingleTriggerMode"
>
  <div icon class="header-icon">
    <mat-icon svgIcon="icon_workflow_16" class="w-16 h-16 icon-16" />
  </div>

  <div title>Trigger a Workflow</div>

  <div actions>
    <blaze-environment-indicator class="ml-auto" />
  </div>

  <div content class="modal-content">
    @if (loading()) {
      <blaze-element-loading-indicator [isVisible]="true" [fadeEnabled]="true" />
    }

    @if (!loading() && form) {
      <div [formGroup]="form">
        <div formArrayName="triggers">
          @for (
            trigger of form.controls.triggers.controls;
            track trigger.value.workflowId;
            let i = $index
          ) {
            @let workflowId = trigger.value.workflowId ?? '';
            @let canEnable =
              canActivateTrigger(workflowId, trigger.value.triggerType, activatedMap());
            @let cycled = cycles().has(workflowId);

            @if (!isSingleTriggerMode || workflowId === singleTriggerModeWorkflowId) {
              <div [formGroupName]="i" class="trigger" data-cy="TriggersDialog:trigger">
                <div class="header">
                  <span class="label">Action {{ i + 1 }}</span>
                  <span class="spacer"></span>

                  <blaze-table-triggers-warnings [cycled]="cycled" [disabled]="!canEnable" />
                  <mat-slide-toggle
                    class="bd-toggle enabler"
                    [class.warn]="cycled"
                    [formControlName]="isActiveControlName"
                    data-cy="TriggersDialog:activateTrigger"
                  />
                  @if (canRemove) {
                    <button
                      blazeButton="skeleton"
                      (click)="requestRemoveTrigger(i)"
                      class="remove"
                      data-cy="TriggersDialog:removeTrigger"
                    >
                      <mat-icon svgIcon="icon_trash_16" />
                    </button>
                  }
                </div>
                @let type = trigger.get('triggerType')?.value;
                <div class="form-field">
                  @let typeFieldId = `${formId}-trigger-type-${i}`;
                  <label [for]="typeFieldId">When data is:</label>
                  <blaze-select
                    [id]="typeFieldId"
                    [value]="type"
                    (valueChange)="changeTriggerType($event, i)"
                    formControlName="triggerType"
                    [options]="TYPE_OPTIONS"
                    [allowNone]="false"
                    [showSelection]="true"
                    [multiselect]="false"
                    class="field field-type"
                    data-cy="TriggersDialog:triggerType"
                  />
                </div>
                @if (type === 'Update' || type === 'Upsert') {
                  @let typeFieldId = `${formId}-input-data-type-${i}`;
                  <div class="form-field">
                    <label [for]="typeFieldId">Input Data:</label>
                    <mat-button-toggle-group
                      [id]="typeFieldId"
                      formControlName="inputData"
                      class="field field-data button-group-input stretch"
                      data-cy="TriggersDialog:inputDataType"
                    >
                      <mat-button-toggle value="NewValue">New Value</mat-button-toggle>
                      <mat-button-toggle value="OldValue">Old Value</mat-button-toggle>
                    </mat-button-toggle-group>
                  </div>
                }
                <div class="form-field">
                  @let workflowFieldId = `${formId}-workflow-${i}`;
                  <label [for]="workflowFieldId">Trigger Workflow:</label>
                  <button
                    [id]="workflowFieldId"
                    blazeButton="skeleton"
                    (click)="requestEditWorkflow(i)"
                    class="field field-workflow"
                    data-cy="TriggersDialog:configureWorkflow"
                  >
                    <mat-icon svgIcon="icon_blaze_16" />
                    {{
                      isWorkflowConfigured(workflowsMap()[workflowId])
                        ? 'EDIT WORKFLOW'
                        : 'CONFIGURE WORKFLOW'
                    }}
                  </button>
                </div>
              </div>
            }
          }
        </div>
      </div>
    }
  </div>

  @if (!loading() && !isSingleTriggerMode) {
    <div footer class="footer">
      <button
        blazeButton="skeleton"
        class="add"
        [disabled]="busy()"
        (click)="requestAddTrigger()"
        data-cy="TriggersDialog:addTrigger"
        >Add Action</button
      >
    </div>
  }
</blaze-dialog>
